// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__VkixV","paramInput":"JobSimulator_paramInput__2R4RP","input":"JobSimulator_input__1G_Qs"};